angular.module('treeRedialChartModule', [])
    .directive('treeRedialChartDir', ['$q', 'initHotHead', '$timeout', 'trsHttpService', function($q, initHotHead, $timeout, trsHttpService) {
        // Runs during compile
        return {
            restrict: 'E',
            replace: true,
            template: "<div ng-style=\"myStyle\" ng-click=\"request(params)\"></div>",
            scope: {
                optionJsons: "="
            },
            link: function(scope, iElement, iAttrs) {
                $timeout(function() {
                    scope.myStyle = {
                        height: '350px',
                        width: '100%'
                    };
                    if(scope.optionJsons=== '') return;
                    var data={
                        name: "集团稿件",
                        children: [
                            {
                                name: "网站",
                                children: [
                                    {
                                        name: "网站",
                                        children: [
                                            {
                                                name: "网站",
                                                value: 3938,
                                            },
                                            {
                                                name: "网站112",
                                                value: 3812,
                                            }
                                        ],
                                    }
                                ],
                            },
                            {
                                name: "客户端",
                                children: [
                                    {
                                        name: "客户端",
                                        value: 17010,
                                    },
                                    {
                                        name: "客户端",
                                        children: [
                                            {
                                                name: "客户端",
                                                value: 1983,
                                            },
                                            {
                                                name: "客户端",
                                                value: 2047,
                                            }
                                        ],
                                    }
                                ],
                            },
                            {
                                name: "微信",
                                children: [
                                    {
                                        name: "微信",
                                        value: 8833,
                                    }
                                ],
                            },
                            {
                                name: "纸媒",
                                children: [
                                    {
                                        name: "纸媒",
                                        value: 4116,
                                    }
                                ],
                            }
                        ],
                    }
                    var option = {
                        tooltip: {
                            trigger: 'item',
                            triggerOn: 'mousemove'
                        },
                        series: [
                            {
                                type: 'tree',
                                data: [data],
                                top: '25%',
                                bottom: '14%',
                                layout: 'radial',
                                symbol: 'emptyCircle',
                                symbolSize: 12,
                                initialTreeDepth:2,
                                animationDurationUpdate: 750,
                                itemStyle:{
                                    borderColor:'#4D8AFF'
                                },
                            }
                        ]
                    }

                    require(['echarts'], function(echarts) {
                        var myChart = echarts.init(iElement[0]);
                        myChart.setOption(option);
                        window.onresize = myChart.resize;
                    });
                }, 500);
            }
        };
    }]);